import { render, staticRenderFns } from "./uploadDialogRecom.vue?vue&type=template&id=d048d3a4&scoped=true&"
import script from "./uploadDialogRecom.vue?vue&type=script&lang=js&"
export * from "./uploadDialogRecom.vue?vue&type=script&lang=js&"
import style0 from "./uploadDialogRecom.vue?vue&type=style&index=0&id=d048d3a4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048d3a4",
  null
  
)

export default component.exports